<template>
  <div class="post-wrap">
    <div class="post-time">{{ createTime }}</div>
    <div class="content-wrap" @click="toTransfer">
      <div class="image-wrap">
        <img v-if="icon" :src="imgThumbPath + icon" />
        <img v-else :src="defaultIcon" />
      </div>
      <div class="title">{{ title }}</div>
    </div>
    <div class="bottom-wrap">
      <div v-if="isShowTransfer">
        <div class="flex">
          <div><van-icon name="eye-o" />{{ resource.valUnique }}</div>
          <div v-if="status !== 0" class="post-status"><van-icon name="friends-o" />{{ status }}</div>
          <div v-if="status === 0 && statusCtrl !== 2" style="color: #d92828">
            <van-icon name="friends-o" />快来转发
          </div>
        </div>
      </div>
      <div class="right">
        <div class="btn" @click.stop="toSource"><van-icon name="column" />原文</div>
        <div v-if="statusCtrl === 2" class="btn" style="color: #d92828"><van-icon name="warning" />已停止</div>
        <div v-if="isShowTransfer && statusCtrl !== 2" class="btn" @click.stop="toTransfer">
          <van-icon name="share" />
          转发
        </div>
      </div>
    </div>
    <div class="bottom-right">
      <div>文章点击量：{{ resource.viewVisit }}</div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { Notify, Dialog, Icon } from 'vant';
import { imgThumbPath } from '@/utils/constant';
import defaultIcon from '@/assets/logo.png';
import { forwardSource } from '@/api/cms';
import Vue from 'vue';

Vue.use(Icon);

export default {
  name: 'PostItem',
  data() {
    return {
      imgThumbPath,
      defaultIcon
    };
  },
  props: {
    isShowTransfer: {
      type: Boolean,
      default: true
    },
    acc: {
      type: String,
      default: '',
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    status: {
      type: Number,
      default: 0
    },
    statusCtrl: {
      type: Number,
      default: 0
    },
    source: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    sourceSelfAcc: {
      type: null,
      default() {
        return null;
      }
    },
    time: {
      type: String,
      default: ''
    },
    resource: {
      type: Object,
      default() {
        return {
          valUnique: 0,
          valVisit: 0,
          viewUnique: 0,
          viewVisit: 0
        };
      }
    }
  },
  computed: {
    createTime() {
      return dayjs(this.time).format('YYYY-MM-DD HH:mm');
    }
  },
  methods: {
    toSource() {
      if (!this.source) {
        Notify({ type: 'warning', message: '文章链接有误' });
        return;
      }
      Dialog({
        message: '在原文右上角点击转发，是不能记录转发操作的哦！',
        confirmButtonText: '我知道了'
      }).then(() => {
        window.location.href = this.source;
      });
    },
    async toTransfer() {
      // 详情页禁止点击跳转
      if (this.$route.name === 'surl') return;
      if (this.sourceSelfAcc) {
        await this.$router.push({
          path: `/surl/${this.sourceSelfAcc}`
        });
      } else {
        try {
          const params = {
            form: {
              acc: this.acc
            }
          };
          const { data } = await forwardSource(params);
          await this.$router.push({
            path: `/surl/${data.meExec.forwardSource.acc}`
          });
        } catch (e) {
          throw new Error(e);
        }
      }
    }
  }
};
</script>

<style scoped lang="less">
.post-wrap {
  background-color: #fff;
  margin-bottom: 15px;
  padding: 10px;
  display: flex;
  border-radius: 4px;
  flex-direction: column;
  font-size: 14px;
  color: #333;
  .post-time {
    color: #888;
    margin-bottom: 6px;
  }
  .content-wrap {
    flex: 1;
    display: flex;
    .image-wrap {
      width: 60px;
      height: 60px;
      margin-right: 10px;
      border-radius: 4px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .title {
      /*overflow: hidden;*/
      /*text-overflow: ellipsis;*/
      /*white-space: nowrap;*/
      font-size: 15px;
      text-align: justify;
      flex: 1;
    }
  }
  .bottom-right {
    display: flex;
    margin-top: 4px;
    justify-content: flex-end;
    color: #666;
  }
  .bottom-wrap {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 8px;
    align-items: center;
    .flex {
      display: flex;
      div {
        margin-right: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          margin-right: 4px;
        }
      }
    }
    .post-status {
      color: #1989fa;
    }
    .right {
      display: flex;
      flex-direction: row;
      flex: 1;
      justify-content: flex-end;
      align-items: center;
      .btn {
        display: flex;
        align-items: center;
        margin-left: 10px;
        color: #666;
        i {
          margin-right: 4px;
        }
      }
    }
  }
}
</style>
